import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Bot } from "lucide-react";
import { Loading } from "@/pages/_shared";
import api from "@/lib/api";

export default function AIEmployees() {
  const [employees, setEmployees] = useState(null);
  useEffect(() => { api.get("/employees").then(({ data }) => setEmployees(data.employees)).catch(() => setEmployees([])); }, []);
  if (!employees) return <Loading />;
  return (
    <div className="animate-fade-up" data-testid="ai-employees-page">
      <h1 className="font-head text-2xl font-extrabold tracking-tight text-slate-900">The Capital Crew</h1>
      <p className="mt-1 text-[13px] text-slate-500">Your specialized AI workforce. Click any employee to see their jobs, activity and assign a mission.</p>
      <div className="mt-5 grid gap-3 sm:grid-cols-2 lg:grid-cols-3">
        {employees.map((e) => (
          <Link key={e.id} to={`/owner/employees/${e.id}`} className="rounded-2xl border border-slate-200 bg-white p-4 transition-colors hover:border-[#1a5fd0]" data-testid="employee-card">
            <div className="flex items-center gap-3">
              <span className={`flex h-11 w-11 items-center justify-center rounded-xl font-head text-sm font-bold ${e.id === "controller" ? "bg-[#080d1a] text-white" : "bg-slate-100 text-slate-700"}`}>
                {e.id === "controller" ? <Bot size={20} /> : e.name.replace("AI ", "")[0]}
              </span>
              <div>
                <div className="font-head text-[14px] font-bold text-slate-900">{e.name}</div>
                <div className="font-mono text-[9px] uppercase tracking-wider text-[#b0862f]">{e.role}</div>
              </div>
            </div>
            <p className="mt-2.5 text-[12px] leading-relaxed text-slate-500">{e.blurb}</p>
            <div className="mt-2 text-[12px] font-semibold text-[#1a5fd0]">Open profile →</div>
          </Link>
        ))}
      </div>
    </div>
  );
}
